import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { verify2FAApi } from "../../redux/apiCalls/authApiCall";

function Verify2FA() {

    const [token, setToken] = useState("");

    const dispatch = useDispatch();

    const submitHandler = (e) => {
        e.preventDefault();

        if (token.trim() === "") return;

        dispatch(verify2FAApi(token));
    }

    return (

        <div style={{ display: "flex", justifyContent: "center", marginTop: "100px" }}>

            <form onSubmit={submitHandler}>

                <h2>Enter 2FA Code</h2>

                <input
                    type="text"
                    placeholder="6 digit code"
                    value={token}
                    onChange={(e) => setToken(e.target.value)}
                    maxLength={6}
                />

                <button type="submit">
                    Verify
                </button>

            </form>

        </div>

    )

}

export default Verify2FA;